/**
 * Sizes
 */

import { baseline } from './grid';

export const Size = {
  appHeaderHeight: baseline * 4,
  pageHeaderHeight: baseline * 7,
  pageWithHeaderMarginTop: baseline * 11,
  playerHeight: baseline * 7,
  playerWithTermListHeight: baseline * 17,
  licenseBarHeight: baseline * 7,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/styles/sizes.ts